import { render } from "./WordList.vue?vue&type=template&id=fd8552e0&scoped=true"
import script from "./WordList.vue?vue&type=script&lang=js"
export * from "./WordList.vue?vue&type=script&lang=js"

import "./WordList.vue?vue&type=style&index=0&id=fd8552e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8552e0"]])

export default __exports__